import { render, staticRenderFns } from "./SearchSelectItem.vue?vue&type=template&id=5439922f&"
import script from "./SearchSelectItem.vue?vue&type=script&lang=ts&"
export * from "./SearchSelectItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports